module.exports = __webpack_public_path__ + "static/media/14.20a943c4.JPG";